import React from 'react';
import { BarChart3 } from 'lucide-react';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CATEGORY_SALES_DATA } from '../../../../mocks/Analytics.mocks';
import '../shared-modules.css';
import '../FinancesView/masters/FinanceReports.css';
import './AnalyticsView.css';

export const AnalyticsView: React.FC = () => {
  return (
    <div className="analytics-container">
      <div className="module-toolbar">
        <div className="fin-reports__heading">
          <BarChart3 size={14} className="module-panel-title-icon" />
          <div>
            <h3 className="fin-reports__title">Business_Intelligence</h3>
            <p className="fin-reports__subtitle">Análisis avanzado de tendencias de mercado y rendimiento de catálogo</p>
          </div>
        </div>
      </div>

      <div className="analytics-grid">
        <div className="analytics-card">
          <h3 className="analytics-card-title">Evolución_de_Ventas</h3>
          <div className="analytics-chart-container">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={CATEGORY_SALES_DATA}>
                <defs>
                  <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="var(--color-brand-green)" stopOpacity={0.3} />
                    <stop offset="95%" stopColor="var(--color-brand-green)" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="name" stroke="var(--color-brand-text)" fontSize={10} tickLine={false} axisLine={false} />
                <YAxis stroke="var(--color-brand-text)" fontSize={10} tickLine={false} axisLine={false} />
                <Tooltip contentStyle={{ background: '#1a1a1a', border: '1px solid #334155', color: 'var(--color-brand-green)' }} />
                <Area type="monotone" dataKey="sales" stroke="var(--color-brand-green)" strokeWidth={2} fillOpacity={1} fill="url(#colorSales)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};
